import { translate, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';

var KeycloakError = /** @class */ (function (_super) {
    __extends(KeycloakError, _super);
    function KeycloakError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(KeycloakError.prototype, "errorMessage", {
        get: function () {
            var _a, _b;
            var isTranslationExists = translate("keycloak.corex.error." + this.kcContext.message) !== '';
            return isTranslationExists
                ? translate("keycloak.corex.error." + ((_a = this.kcContext.message) === null || _a === void 0 ? void 0 : _a.type))
                : (_b = this.kcContext.message) === null || _b === void 0 ? void 0 : _b.summary;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop(Object),
        __metadata("design:type", Object)
    ], KeycloakError.prototype, "kcContext", void 0);
    KeycloakError = __decorate([
        Component({
            name: 'corex-keycloak-error',
        })
    ], KeycloakError);
    return KeycloakError;
}(Mixins(MagicConfigMixin)));

export default KeycloakError;
